(function ($, Promise) {

        // Setup the prototype inheritance
        extend(BaseGamePAC, PACCarteMontreal);

        // Constructor
        function PACCarteMontreal() {

            // this.defaultEasing = CustomEase.create("custom", "0.65, 0, 0.35, 1");
            // this.defaultEasing = CustomEase.create("custom", "0.33, 1, 0.68, 1");
            // this.defaultEasing = CustomEase.create("custom", "0, 0.55, 0.45, 1");
            this.defaultEasing = CustomEase.create("custom", "M0,0 C0,0 0.108,0.051 0.152,0.114 0.263,0.272 0.424,1 0.96,1 0.984,1 1,1 1,1");
            // this.defaultEasingIn = CustomEase.create("custom", "0.3, 0.0, 0.9, 1");
            // this.defaultEasingOut = CustomEase.create("custom", "0.1, 0.0, 0.7, 1");

            // Super constructor
            BaseGamePAC.call(this, "data/carte-montreal.json");

            this.tilteDestination = {
                x: -25,
                y: -120,
                scale: 0.3,
            }

            this.selectedRoute = false;

            this.cardTimeline = false;
            this.routeTimeline = false;
            this.statsTimeline = false;
            this.tabTimeline = false;
            this.locked = false;
        }


        // To be overriden in child games
        PACCarteMontreal.prototype.buildDOM = function () {
            return new Promise($.proxy(function (resolve, reject) {

                this.screensaver = new PACCarteMontrealScreenSaver();

                // gsap.registerPlugin(DrawSVGPlugin);
                gsap.config({
                    force3D: false,
                    nullTargetWarn: false
                });

                // Map POI pins
                $("#map #map-explore-overlay .map-poi-pin").on("click", $.proxy(function (e) {
                    if (this.locked || $("#map .map-poi-pin.active").length > 0) {
                        return;
                    }
                    var $el = $(e.currentTarget);
                    e.stopImmediatePropagation();
                    this.selectPOI($el.data("poi-index"));
                }, this));

                // Map ROUTES POI pins
                $("#map #map-routes-overlay .map-poi-pin").on("click", $.proxy(function (e) {
                    if (this.locked) {
                        return;
                    }
                    e.stopImmediatePropagation();
                    var $el = $(e.currentTarget);
                    var slideIndex = parseInt($el.data("poi-index"));
                    var swiper = $("#sidebar-routes .details-card.active").find(".details-slider").data("swiper")
                    swiper.slideTo(slideIndex);
                }, this));

                // Side bar explore selecte item
                $("#sidebar-explore .list .item").on("click", $.proxy(function (e) {
                    e.stopImmediatePropagation();
                    var $el = $(e.currentTarget);
                    this.selectPOI($el.data("poi-index"));
                }, this));

                // Side bar routes selecte item
                $("#sidebar-routes .list .item").on("click", $.proxy(function (e) {
                    e.stopImmediatePropagation();
                    var $el = $(e.currentTarget);
                    this.selectRoute($el.data("route-index"));
                }, this));

                // Impetueus plugin used for explore list
                this.impetusExploreList = new Impetus({
                    source: "#sidebar-explore .list",
                    boundX: [0, 1],
                    boundY: [0, 1],
                    update: this.updateImpetusPosition
                });
                this.impetusExploreList.source = $("#sidebar-explore .list");
                this.impetusExploreList.draggableElement = $("#sidebar-explore .list .content");
                this.enableImpetus(false, this.impetusExploreList, true);
                $("#sidebar-explore .list").data("impetus", this.impetusExploreList)

                // Build routes sliders
                $("#sidebar-routes .details-slider").each($.proxy(function (i, n) {
                    var swiper = new Swiper($(".swiper-container", n).get(0), {
                        speed: 700,
                        spaceBetween: 0,
                    });
                    swiper.on("slideChange", $.proxy(this.onRoutePOISelect, this, swiper))
                    $(n).data("swiper", swiper);
                }, this));

                // Sidebar routes - Select person slide (index 0)
                $("#sidebar-routes .details-perso-button").on("click", $.proxy(function (e) {
                    e.stopImmediatePropagation();
                    var $el = $(e.currentTarget);
                    var swiper = $el.parents(".details-card").find(".details-slider").data("swiper")
                    swiper.slideTo(0);
                }, this));

                // Sidebar routes - Select poi slide
                $("#sidebar-routes .details-route-button").on("click", $.proxy(function (e) {
                    e.stopImmediatePropagation();
                    var $el = $(e.currentTarget);
                    var slideIndex = parseInt($el.data("poi-index"));
                    var swiper = $el.parents(".details-card").find(".details-slider").data("swiper")
                    swiper.slideTo(slideIndex);
                }, this));

                $("#map-explore-overlay").on("click", $.proxy(function (e) {
                    console.log("map-explore-overlay");
                    if ($("#map-explore-overlay").hasClass("poi-opened")) {
                        e.stopImmediatePropagation();
                        this.closeDetailsCard();
                    }
                }, this));

                // Load SVGs
                // window.convertSVGToInline();
                window.convertSVGToInline(function (img) {
                    if ($(img).parent().hasClass("map-poi-path")) {
                        TweenMax.set(img.find("mask path").get(0),
                            {drawSVG: "0%"},
                        );
                    }
                });

                $("#main").addClass("ready");

                resolve();

            }, this));
        }

        // To be overriden in child games
        PACCarteMontreal.prototype.initGame = function () {
            console.log("init game");

            // Go to first screen
            this.initScreenSaver();
            this.goToScreen(1);

            // this.goToScreen(2);

            this.selectTab("infos");
            // this.selectTab("explore");
            // this.selectTab("routes");

            this.selectUnit("toises");
            // this.selectUnit("horse");
        };

        // Overriding goToScreen for some custom animations
        // PACCarteMontreal.prototype.goToScreen = function (screenId, callback) {
        //
        // // Super constructor
        // if (BaseGame.prototype.goToScreen.call(this, screenId, callback) == false) {
        // return false;
        // }
        //
        // if (this.currentScreen == 1 && screenId == 2) {
        //     this.placeTitle("small", "show");
        //     $(".page-grid .image-wrapper").show();
        // }
        // }

        // To be overriden in child games
        PACCarteMontreal.prototype.initScreen = function (screenId) {

            // Super constructor
            if (BaseGame.prototype.initScreen.call(this, screenId) == false) {
                return false;
            }

            switch (screenId) {
                case 1:
                    this.reset();
                    this.placeTitle("big");
                    this.toggleLanguageButton(false);
                    ;
                    this.screensaver.start();
                    break;
                case 2:
                    this.placeTitle("small");
                    this.toggleLanguageButton(true);
                    $(".page-grid .image-wrapper").show();
                    this.screensaver.stop();
                    break;
                case 3:
                    this.placeTitle("small");
                    this.screensaver.stop();
                    break;
            }

        }

        PACCarteMontreal.prototype.start = function (language) {

            // Super constructor
            if (BaseGame.prototype.start.call(this) == false) {
                return;
            }

            console.log("starting in ", language)
        }

        PACCarteMontreal.prototype.selectIntroLanguage = function (e) {

            var language = $(e.currentTarget).data("lang");
            this.i18n.setWithFlip(language);

            if (this.timeout != false) {
                clearTimeout(this.timeout);
                this.timeout = false;
            }
            this.timeout = setTimeout($.proxy(function () {
                this.goToScreen(2);
            }, this), 200)

            this.placeTitle("small");
        }

        PACCarteMontreal.prototype.selectTab = function (name) {

            if (this.locked) {
                return;
            }

            var $currentTabContent = $(".sidebar-tab-content.active");
            var $newTabContent = $(".sidebar-tab-content#sidebar-" + name);

            if ($currentTabContent.is($newTabContent)) {
                return;
            }

            this.locked = true;

            if (this.tabTimeline != false) {
                this.tabTimeline.kill();
                this.tabTimeline = false;
            }

            this.tabTimeline = new TimelineMax();

            this.closeDetailsCard(true);

            // Animate out
            if ($currentTabContent.length > 0) {
                this.tabTimeline.to($currentTabContent, 0.4, {
                    autoAlpha: 0,
                    y: 100,
                    ease: this.defaultEasing,
                });
            }

            // Animate in
            this.tabTimeline.fromTo($newTabContent, 0.4, {
                y: 100,
            }, {
                autoAlpha: 1,
                y: 0,
                ease: this.defaultEasing,
            }, "-=0.2");

            // Update tab content classes
            this.tabTimeline.add(function () {
                $currentTabContent.removeClass("active")
                $newTabContent.addClass("active")
            }, 0);

            // Reset scroll position
            this.tabTimeline.add(function () {
                $("#sidebar-explore .list .content").css("transform", "translate3D(0, 0, 0)")
            }, "+=0");

            this.tabTimeline.add($.proxy(function () {
                this.enableImpetus(true, this.impetusExploreList, true);
                this.locked = false;
            }, this), "+=0.3");

            // Update tab classes
            $("#sidebar-tabs .sidebar-tab").removeClass("active");
            $("#sidebar-tabs .sidebar-tab[data-action-arg='" + name + "']").addClass("active");

            // Open related map overlay
            $(".map-overlay").removeClass("active")
            if (name == "explore") {
                $("#map-explore-overlay").addClass("active")
            } else if (name == "routes") {
                $("#map-routes-overlay").addClass("active")
            }
        }

        PACCarteMontreal.prototype.selectPOI = function (poiIndex) {
            console.log("selectPOI", poiIndex);

            // Kill current animation, if any
            if (this.routeTimeline != false) {
                this.routeTimeline.kill();
                this.routeTimeline = false;
            }

            // Open details card
            this.openDetailsCard("explore-details-card-" + poiIndex, poiIndex);

            $(".map-poi-path").removeClass("active");
            $(".map-poi-path[data-poi-index=" + poiIndex + "]").addClass("active");
            $(".map-poi-pin[data-poi-index=" + poiIndex + "]").addClass("selected");
            $("#map-explore-overlay").addClass("poi-opened");

            // var duration = this.data.points_of_interest[poiIndex].duration / 10;
            var duration = 0.5;
            console.log("selectPOI - animate path in", duration);

            this.routeTimeline = new TimelineMax();
            this.routeTimeline.fromTo(".map-poi-path.active .path mask path", duration, {
                drawSVG: "0%"
            }, {
                drawSVG: "100%",
                ease: "none",
                onUpdate: function () {
                    this.locked = false;
                },
                callbackScope: this
            }, "+=0.1");
            this.routeTimeline.add($.proxy(function () {
                $(".map-poi-pin[data-poi-index=" + poiIndex + "]").addClass("active");
                this.locked = false;
            }, this));
        }

        PACCarteMontreal.prototype.selectRoute = function (routeIndex) {
            console.log("selectRoute", routeIndex);

            if (this.locked) {
                return;
            }

            this.selectedRoute = routeIndex;

            // Open details card
            this.openDetailsCard("route-details-card-" + routeIndex, routeIndex);

            // Handle map overlay
            $(".map-route").removeClass("active");
            $(".map-route .map-poi-pin").removeClass("active");
            $(".map-route[data-route-index=" + routeIndex + "]").addClass("active");

            // Reset path
            TweenMax.set(".map-route.active .path mask path",
                {drawSVG: "0%"},
            );
        }

        PACCarteMontreal.prototype.openDetailsCard = function (elId, index) {

            if (this.locked) {
                return;
            }

            this.locked = true;
            var $newCardContent = $("#" + elId);
            var $defaultContent = $newCardContent.parents(".sidebar-tab-content").find(".default-content");

            if (this.cardTimeline != false) {
                this.cardTimeline.kill();
                this.cardTimeline = false;
            }

            this.cardTimeline = new TimelineMax();

            // Disable impetus and update classes
            this.cardTimeline.add($.proxy(function () {
                this.enableImpetus(false, this.impetusExploreList, false);
                $newCardContent.addClass("active")
                $newCardContent.parents(".sidebar-tab-content").addClass("card-opened");
            }, this));

            // Animate items according to their data behaviour
            this.cardTimeline.to($defaultContent.find("*[data-card-opened-behaviour='hide']"), 0.6, {
                alpha: 0,
                ease: Sine.easeInOut,
            }, 0.2);

            // Animate items according to their data behaviour
            this.cardTimeline.to($defaultContent.find("*[data-card-opened-behaviour='down']"), 0.6, {
                alpha: 0,
                y: 300,
                ease: Sine.easeInOut,
            }, 0.2);

            // Animate items according to their data behaviour (cloned images)
            var cloneTarget = $defaultContent.find("*[data-card-opened-behaviour='clone-and-scale']").eq(index);
            if (cloneTarget.length > 0) {
                var clone = cloneTarget.clone();
                $("#item-clone").remove()
                clone.attr("id", "item-clone")
                clone.css({
                    top: "",
                    left: "",
                    position: "absolute",
                    zIndex: 10,
                    overflow: "hidden",
                });
                clone.data("original-x", cloneTarget.offset().left);
                clone.data("original-y", cloneTarget.offset().top);
                clone.data("original-w", cloneTarget.width());
                clone.data("original-h", cloneTarget.height());
                $("img", cloneTarget).css("opacity", 0);
                $("#main #screen-2").append(clone)

                this.cardTimeline.fromTo(clone, 0.8, {
                    x: clone.data("original-x"),
                    y: clone.data("original-y")
                }, {
                    x: $("#sidebar-routes").offset().left,
                    y: $("#sidebar-routes").offset().top,
                    width: 470,
                    height: 185,
                    ease: Sine.easeInOut,
                }, 0.0);

                var sourceImageTransform = this.data.routes[index].image.thumbnail;
                var targetImageTransform = this.data.routes[index].image.full;
                clone.data("original-image-x", sourceImageTransform.x);
                clone.data("original-image-y", sourceImageTransform.y);
                clone.data("original-image-scale", sourceImageTransform.scale);
                this.cardTimeline.fromTo($("img", clone), 0.8, {
                    x: (sourceImageTransform.x * 100) + "%",
                    y: (sourceImageTransform.y * 100) + "%",
                    scale: sourceImageTransform.scale,
                }, {
                    x: (targetImageTransform.x * 100) + "%",
                    y: (targetImageTransform.y * 100) + "%",
                    scale: targetImageTransform.scale,
                    ease: Sine.easeInOut,
                }, 0.0);
            }

            // Animate items according to their data behaviour
            this.cardTimeline.fromTo($newCardContent.find("*[data-card-opened-behaviour='reveal'] > .inner"), 0.6, {
                y: -300,
            }, {
                alpha: 1,
                y: 0,
                ease: Sine.easeInOut,
            }, 0.8);

            // Animate items according to their data behaviour
            this.cardTimeline.fromTo($newCardContent.find("*[data-card-opened-behaviour='up']"), 0.6, {
                alpha: 0,
                y: 100,
            }, {
                alpha: 1,
                y: 0,
                ease: Sine.easeInOut,
            }, 0.8);

            // Animate card in fade in
            this.cardTimeline.fromTo($newCardContent, 1.2, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
                ease: this.defaultEasing,
            }, 0.8);

            // Disable impetus and update classes
            this.cardTimeline.add($.proxy(function () {
                this.locked = false;
            }, this));
        }

        PACCarteMontreal.prototype.closeDetailsCard = function (force) {

            console.log("closeDetailsCard")

            if (this.locked && force != true) {
                return;
            }

            if (this.routeTimeline != false) {
                this.routeTimeline.kill();
                this.routeTimeline = false;
            }

            this.locked = true;
            var $currentCardContent = $(".details-card.active");
            var $defaultContent = $currentCardContent.parents(".sidebar-tab-content").find(".default-content");

            this.clearMap();

            if (this.cardTimeline != false) {
                this.cardTimeline.progress(1).kill();
                this.cardTimeline = false;
            }

            if ($currentCardContent.length > 0) {

                this.cardTimeline = new TimelineMax();

                // Bring card down
                this.cardTimeline.to($currentCardContent, 0.4, {
                    autoAlpha: 0,
                    // y: 900,
                    ease: this.defaultEasing,
                });

                // Animate items according to their data behaviour (cloned images)
                if ($("#item-clone").length > 0) {
                    if (force != true) {
                        this.cardTimeline.to($("#item-clone"), 0.8, {
                            x: $("#item-clone").data("original-x"),
                            y: $("#item-clone").data("original-y"),
                            width: $("#item-clone").data("original-w"),
                            height: $("#item-clone").data("original-h"),
                            ease: this.defaultEasing,
                        }, 0.2);

                        // var sourceImageTransform = this.data.routes[index].image.thumbnail;
                        // var targetImageTransform = this.data.routes[index].image.full;
                        this.cardTimeline.to($("#item-clone img"), 0.8, {
                            x: ($("#item-clone").data("original-image-x") * 100) + "%",
                            y: ($("#item-clone").data("original-image-y") * 100) + "%",
                            scale: $("#item-clone").data("original-image-scale"),
                            ease: Sine.easeInOut,
                        }, 0.2);
                    }

                    this.cardTimeline.add(function () {
                        $("#item-clone").remove();
                        $defaultContent.find("*[data-card-opened-behaviour='clone-and-scale'] > img").css("opacity", 1);
                    }, (force != true) ? "+=0.0" : 0);
                }

                // Update tab content classes
                this.cardTimeline.add(function () {
                    $currentCardContent.removeClass("active");
                    $currentCardContent.parents(".sidebar-tab-content").removeClass("card-opened");
                }, 0.4);

                // Animate items according to their data behaviour
                this.cardTimeline.to($defaultContent.find("*[data-card-opened-behaviour='hide']"), 0.6, {
                    alpha: 1,
                    ease: Sine.easeInOut,
                }, 0.2);

                // Animate items according to their data behaviour
                this.cardTimeline.to($defaultContent.find("*[data-card-opened-behaviour='down']"), 0.6, {
                    alpha: 1,
                    y: 0,
                    ease: Sine.easeInOut,
                }, 0.2);


                // Animate items according to their data behaviour
                this.cardTimeline.to($currentCardContent.find("*[data-card-opened-behaviour='up']"), 0.4, {
                    alpha: 0,
                    y: 100,
                    ease: Sine.easeInOut,
                }, 0.01);

                // Re-enable impetus
                this.cardTimeline.add($.proxy(function () {
                    this.enableImpetus(true, this.impetusExploreList, false);
                    if ($currentCardContent.find(".details-slider").length != 0) {
                        $currentCardContent.find(".details-slider").data("swiper").slideTo(0, 0)
                    }
                    if (force != true) {
                        this.locked = false;
                    }
                }, this));

            } else {
                this.locked = false;
            }
        }

        PACCarteMontreal.prototype.clearMap = function () {
            $(".map-poi-pin").removeClass("active selected");
            $(".map-poi-path").removeClass("active");
            $(".map-route").removeClass("active");
            $(".map-route .map-poi-pin").removeClass("active");
            $("#map-explore-overlay").removeClass("poi-opened");
        }

        PACCarteMontreal.prototype.onRoutePOISelect = function (swiper) {
            var activeSlideIndex = swiper.activeIndex;
            console.log("onRoutePOISelect", activeSlideIndex)

            // Update active state classes
            var $buttons = $(swiper.el).parents(".details-card").find(".round-button");
            $buttons.removeClass("active").eq(activeSlideIndex).addClass("active");

            // Update active state on map overlay
            $(".map-route.active .map-poi-pin").removeClass("active");
            $(".map-route.active .map-poi-pin").eq(activeSlideIndex).addClass("active");

            // Kill current animation, if any
            if (this.routeTimeline != false) {
                this.routeTimeline.kill();
                this.routeTimeline = false;
            }

            // Animate path mask
            if (this.selectedRoute !== false) {
                var progressOnPath = this.data.routes[this.selectedRoute].points_of_interest[activeSlideIndex].path_progress;
                var currentPosition = DrawSVGPlugin.getPosition(".map-route.active .path mask path")[1] / DrawSVGPlugin.getLength(".map-route.active .path mask path");
                var duration = Math.abs(currentPosition - progressOnPath) * 3.4;
                this.routeTimeline = new TimelineMax();
                this.routeTimeline.to(".map-route.active .path mask path", duration, {
                        drawSVG: (progressOnPath * 100) + "%",
                        ease: "none",
                    },
                );
            }
        }

        PACCarteMontreal.prototype.selectUnit = function (unit) {
            var group = false;
            if (unit == "meters" || unit == "toises") {
                group = "distance";
            } else if (unit == "walk" || unit == "horse") {
                group = "duration";
            }

            // Update stats buttons
            $("." + group + "-mode").removeClass("active");
            $("." + group + "-mode[data-mode='" + unit + "']").addClass("active");

            // Define new active stats values
            var $currentStat = $(".stats-" + group + " .mode.active");
            var $newStat = $(".stats-" + group + " .mode[data-mode='" + unit + "']");
            $currentStat.removeClass("active");
            $newStat.addClass("active");

            if ($currentStat[0] == $newStat[0]) {
                return;
            }

            // Animate stats values
            if (this.statsTimeline != false) {
                this.statsTimeline.progress(1).kill();
                this.statsTimeline = false;
            }
            this.statsTimeline = new TimelineMax();
            this.statsTimeline.to($currentStat, 0.4, {
                y: -10,
                autoAlpha: 0,
                ease: this.defaultEasing,
            });
            this.statsTimeline.fromTo($newStat, 0.4, {
                y: 10,
                autoAlpha: 0,
            }, {
                y: 0,
                autoAlpha: 1,
                ease: this.defaultEasing,
            });

        }

        // PACCarteMontreal.prototype.placeTitle = function (titleMode, textMode) {
        //     BaseGamePAC.prototype.placeTitle.call(this, titleMode, textMode);
        // }


        // PACLexique.prototype.placeTitle = function (titleMode) {
        //
        //     if (titleMode == "small") {
        //
        //         if (titleMode == this.currentTitleMode) {
        //             return;
        //         }
        //
        //         if (this.titleTimeline) {
        //             this.titleTimeline.kill();
        //             this.titleTimeline = false;
        //         }
        //
        //         this.titleTimeline = new TimelineMax();
        //
        //         this.titleTimeline.to($("#game-title"), 0.95, {
        //             x: -50,
        //             y: -50,
        //             scale: 0.65,
        //             transformOrigin: "left top",
        //             ease: this.defaultEasing,
        //         });
        //         this.titleTimeline.to($("#game-title .subtitle"), 0.45, {
        //             y: -20,
        //             autoAlpha: 0,
        //             ease: this.defaultEasing,
        //         }, 0);
        //
        //         this.currentTitleMode = titleMode;
        //
        //     } else if (titleMode == "big") {
        //         BaseGamePAC.prototype.placeTitle.call(this, titleMode, textMode);
        //     }
        // }

        PACCarteMontreal.prototype.enableImpetus = function (toggleValue, impetus, resetValue) {

            if (toggleValue == true) {

                if (resetValue) {
                    impetus.setValues(0, 0);
                }

                // Enable Impetus scrolling
                if (impetus.draggableElement.height() > impetus.source.height()) {
                    impetus.paused = false;
                    impetus.setBoundY([-(impetus.draggableElement.outerHeight() - impetus.source.height()), 0]);
                    // this.updateImpetusPosition(0, impetusLastPosition);
                    impetus.setMultiplier(1);
                    impetus.resume();
                }

            } else {
                // Disable Impetus scrolling
                impetus.paused = true;
                impetus.setMultiplier(0);

                if (resetValue) {
                    impetus.setValues(0, 0);
                }

                impetus.pause();
            }
        }

        PACCarteMontreal.prototype.updateImpetusPosition = function (x, y) {
            var impetus = $(this).data("impetus")
            if (impetus.paused == false) {
                impetus.draggableElement.css("transform", "translate3D(0, " + y + "px, 0)")
            }
        }

        // To be overriden in child games
        PACCarteMontreal.prototype.toggleLayers = function (e) {
            if ($("#toggle-layers").hasClass("active")) {
                $("#toggle-layers").removeClass("active");
                $("#sidebar").removeClass("disabled");
                TweenMax.to("#layers", 0.35, {
                        autoAlpha: 0,
                        ease: this.defaultEasing,
                    },
                );

            } else {
                $("#toggle-layers").addClass("active");
                $("#sidebar").addClass("disabled");
                TweenMax.to("#layers", 0.35, {
                        autoAlpha: 1,
                        ease: this.defaultEasing,
                    },
                );

                var eventType = e.type.startsWith("touch") ? "touchend" : "mouseup";
                $(document).one(eventType, $.proxy(this.toggleLayers, this));
            }
        }


        PACCarteMontreal.prototype.reset = function (screenId) {

            // Super
            if (BaseGamePAC.prototype.reset.call(this, screenId) == false) {
                return false;
            }

            this.selectTab("infos");
            this.selectUnit("toises");
            this.selectUnit("horse");

            this.selectedRoute = false;

            if (this.redirectTimeout != false) {
                clearTimeout(this.redirectTimeout);
                this.redirectTimeout = false;
            }

        }

        // Expose PACCarteMontreal
        window.PACCarteMontreal = PACCarteMontreal;
    }
)
(jQuery, Promise);
